(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8786],{

/***/ 52732:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/about-us",
      function () {
        return __webpack_require__(68212);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_themeImports__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53978);
/* harmony import */ var _utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98616);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);





var AboutUs = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "PremiumAboutUs",
        children: [
            (ref = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_3__/* .specificThemeRender */ .t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "PremiumAboutUs__wrapper",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "PremiumAboutUs__wrapper--inner",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "section-top",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "PremiumAboutUs--heading",
                                    children: "About Us"
                                }),
                                (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.store_info) === null || ref3 === void 0 ? void 0 : ref3.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "PremiumAboutUs--paragraph selected-text",
                                    children: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.description
                                })
                            ]
                        }),
                        (ref5 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_3__/* .specificThemeRender */ .t)(storeInfo)) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.components) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Footer) === null || ref7 === void 0 ? void 0 : ref7.map(function(layout) {
                            return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AboutUs);


/***/ }),

/***/ 68212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67046);
/* harmony import */ var _containers_AboutUs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29011);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);
/**
 * Add New Address Route
 */ 






var AboutUsPage = function(props) {
    var ref;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: "About us - Now Shop Online",
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image,
        metaDescription: "Now order online from my whatsapp store & pay using 150+ UPI Apps",
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_AboutUs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (AboutUsPage);


/***/ }),

/***/ 98616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56714);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [740,7046,9774,2888,179], function() { return __webpack_exec__(52732); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);